import React from "react";

interface AProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
	href: string | null | undefined;
	fallbackTag?: React.ElementType;
}

/**
 * A conditional anchor component that renders as either an anchor tag or a fallback element.
 *
 * When a valid href is provided, renders as an anchor element with all standard anchor attributes.
 * When href is null or undefined, renders as the specified fallbackTag (defaults to span) to maintain
 * layout while avoiding invalid anchor elements.
 */
export default function A({ href, fallbackTag: Fallback = "span", children, ...rest }: AProps) {
	if (href) {
		return (
			<a href={href} {...rest}>
				{children}
			</a>
		);
	}

	return <Fallback {...rest}>{children}</Fallback>;
}
